
import ScanFlagIllustration from "@/app/ui/components/scan-flags/index.vue";
import { getScanFlags, hasScanFlags } from "@/domain/entities/ScanFlags";
import { mixins, Options } from "vue-class-component";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import OverlayPanel from "primevue/overlaypanel";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { capitalize } from "vue";
import InputDimension from "@/app/ui/components/input-dimension/index.vue";
import InputAdornment from "@/app/ui/components/input-adornment/index.vue";
import debounce from "lodash/debounce";
import { AccountEntities } from "@/domain/entities/Account";
import { BaggingController } from "@/app/ui/controllers/BaggingController";
import {
  convertDecimal
} from "@/app/infrastructures/misc/Utils";
import formatByCountry, { resolveCountry } from "@/app/infrastructures/misc/common-library/FormatByCountry";
import formatInputByCountry, { parseByCountry } from "@/app/infrastructures/misc/common-library/FormatInputByCountry";
import Print from "../../modules/print.vue";
import {
  BaggingData,
  SttResult,
  ResponseUpdate,
  SttNumberDetail,
  BaggingScanFailed
} from "@/domain/entities/Bagging";
import { LocationController } from "@/app/ui/controllers/LocationController";
import DownloadCsv from "@/app/ui/views/out-going-shipment/out-going-mixin";
import { getScanNotificationSound, playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import { TrackingController } from "@/app/ui/controllers/TrackingController";
import isFormatLiloBag from "@/app/infrastructures/misc/common-library/isFormatLiloBag";
import { formatInputNoDecimal } from "@/app/infrastructures/misc/common-library/FormatInputNoDecimal";
import ScanFailedCard from "../../component/scan-failed-card/index.vue";
import SectionUploadPhotoForWeightAdjusment from "../section-upload-photo-for-weight-adjustment/index.vue";
import { UploadMultiple } from "@/domain/entities/MainApp";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { DeleteHydraFileRequest, UploadHydraFileRequest } from "@/data/payload/api/BookingRequest";
import { flags } from "@/feature-flags";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import { FlagsPermissionBagging } from "@/feature-flags/flags-permission-bagging";

@Options({
  components: {
    ScanFlagIllustration,
    DetailLayout,
    OverlayPanel,
    InputDimension,
    InputAdornment,
    Print,
    ScanFailedCard,
    SectionUploadPhotoForWeightAdjusment
  },
  watch: {
    'form.weight'(newVal: string) {
      const weight = this.parseWeightInput(newVal);
      const length = Number(this.form.length);
      const width = Number(this.form.width);

      if (isNaN(weight) || isNaN(length) || isNaN(width) || length === 0 || width === 0) {
        this.form.height = 0;
        return;
      }

      const result = (weight * this.dimensionDivider) / (length * width);
      const decimalPart = result - Math.floor(result);

      let finalHeight;

      if (decimalPart > 0) {
        finalHeight = Math.floor(result);
        if (finalHeight === 0) finalHeight = 1;
      } else {
        finalHeight = result;
      }

      if (!this.isFirstLanding) {
      this.form.height = finalHeight;
      }
      this.recalculateHeight();
    this.updateTotalBagVolumeWeight();
    },
    'form.length'() {
    this.updateTotalBagVolumeWeight();
  },
  'form.width'() {
    this.updateTotalBagVolumeWeight();
  },
  'form.height'() {
    this.updateTotalBagVolumeWeight();
  },
  },

  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess && !this.isPartial) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      this.setPartial(false);
      this.setFailed(false);
      this.setOpenSuccess(false);
      next();
    }
  }
})
export default class UpdateFormBaggingManifest extends mixins(DownloadCsv) {
  alertDangerousGoods = false;
  pagination = {
    page: 1,
    limit: 50
  };
  refs: any = this.$refs;
  isErrorBagging = false;
  messageErrorNotification = "";
  notificationTimeout?: NodeJS.Timeout = undefined;
  isGrossWeightDiff = false;
  openAdjustmentWeight = true;
  isDimensionChange = true;
  isFirstLanding = true;
  weightVolumeBagData = 0;

  get isValidationPhotoProofHasPermission() {
    return FlagsPermissionBagging.validation_adjust_weight_proof_photo_enable.isEnabled();
  }

   get isValidationAdjustWeightProofPhotoEnable() {
    const validation = this.bagWeightOverSttWeight && this.isValidationPhotoProofHasPermission && !this.isFirstLanding;

    if (!validation) this.photoProof = [];

    return validation;
  }

  get isShowRTC() {
    return flags.feature_rtc_bagging_enabled.isEnabled();
  }

  

  
    get grossWeight() {
      return this.detailData.sttResult.reduce((sum, item) => sum + item.sttGrossWeight, 0)
    }
    get volumeWeight() {
        return this.detailData.sttResult.reduce((sum, item) => sum + item.sttVolumeWeight, 0)
    }
    
    get sttChargeableWeight(): number {
      return this.grossWeight > this.volumeWeight
        ? this.grossWeight
        : this.volumeWeight;
    }
    
    get bagWeightOverSttWeight() {
    const chargeableWeightStt = this.sttChargeableWeight;
    const chargeableWeightBag = this.totalBagChargeableWeight;
    return chargeableWeightBag >= (chargeableWeightStt + 1)
  }

  get maxWeightDispute() {
    return FlagsPermissionBagging.config_max_weight_dispute_bagging.getValue()
  }

  get isAnySttMaxDisputeWhitelisted() {
    const whitelistData = FlagsPermissionBagging.config_whitelist_client_max_weight_dispute.getValue() as number[]
    return this.hasClientId(whitelistData)
  }

  get whitelistFlags() {
    return FlagsPermissionBagging.config_whitelist_client_max_weight_dispute.getValue() as number[]
  }

  get isMaxWeightDispute() {
    const chargeableWeightStt = this.sttChargeableWeight;
    const chargeableWeightBag = this.totalBagChargeableWeight;

    if (this.isAnySttMaxDisputeWhitelisted) return false
    if (!this.maxWeightDispute) return false
    return chargeableWeightBag > Number(Number(chargeableWeightStt + this.maxWeightDispute || 0).toFixed(2))
  }

  hasClientId(clientIdList: number[]) {
    const set = new Set(clientIdList);

    for (let i = 0; i < this.detailData.sttResult.length; i++) {
      if (set.has(this.detailData.sttResult[i].sttClientId)) {
        return true;
      }
    }

    return false;
  }

  get totalBagVolumeWeight(): number {
    if (this.isFirstLanding) {
      return this.detailData.totalBagChargeableWeight;
    } else {
      return this.parseWeightInput(this.form.weight);
    }
  }
   isChangeWeight = false;
  get weightVolumeBag(): number {
    if (this.isChangeWeight) {
      const weight = this.parseWeightInput(this.form.weight);

      let rounded;
      if (weight < 1) {
        rounded = 1; // anything below 1 becomes 1
      } else {
        rounded = Math.round(weight); // otherwise normal rounding
      }

      return rounded;
    }

    if (this.isFirstLanding) {
      const weight = this.detailData.totalBagVolumeWeight;
      this.weightVolumeBagData = Number(weight);
      return Number(weight);
    }
    this.weightVolumeBagData = this.detailData.totalBagChargeableWeight;
    const val = Math.round(this.detailData.totalBagChargeableWeight);
    return isNaN(val) || val === 0 ? 1 : val;
  }

  // format total kg
  convertTotalKg(value: number): number {
    return value;
  }

  formatWeight(n: number): string {
    return formatByCountry(n, { type: "weight", suffix: " Kg" });
  }

  formatWeightInput(value: string | number): string {
    if (typeof value === "number") {
      return formatByCountry(value, { type: "weight" });
    }
    return formatInputByCountry(this.normalizeWeightInput(value), { type: "weight" });
  }

  normalizeWeightInput(value: string): string {
    const normalized = value.replace(/[^\d.,-]/g, "");
    const decimalIndex = Math.max(
      normalized.lastIndexOf("."),
      normalized.lastIndexOf(",")
    );
    const fraction = normalized.slice(decimalIndex + 1);
    if (decimalIndex < 0 || !fraction || fraction.length > 2) {
      return normalized;
    }
    const decimal = resolveCountry() === "MY" ? "." : ",";
    return `${normalized.slice(0, decimalIndex)}${decimal}${fraction}`;
  }

  parseWeightInput(value: string | number): number {
    return parseByCountry(
      typeof value === "number" ? value : this.normalizeWeightInput(value)
    );
  }

  formatCod(amount: number): string {
    return formatByCountry(amount, { type: "money", prefix: "Rp" });
  }

   recalculateHeight() {
    const weight = this.parseWeightInput(this.form.weight);
    const length = Number(this.form.length);
    const width = Number(this.form.width);

    if (isNaN(weight) || isNaN(length) || isNaN(width) || length === 0 || width === 0) {
      this.form.height = 0;
      return;
    }

    const result = (parseByCountry(String(this.weightRoundUpCustom)) * this.dimensionDivider) / (Number(length) * Number(width));
    if (!this.isFirstLanding) {
    this.form.height = Math.floor(result);
    }
  }

  // hitung total bag volume weight
  updateTotalBagVolumeWeight() {
    const length = Number(this.form.length);
    const width = Number(this.form.width);
    const height = Number(this.form.height);

    if (!length || !width || !height) {
      this.detailData.totalBagChargeableWeight = 0;
      return;
    }

    const total = (length * width * height) / this.dimensionDivider;
    if (!this.isFirstLanding) {
    this.detailData.totalBagChargeableWeight = total ? Math.round(total) : 0 ;
    }
  }

  changeDimension(val: any) {
    if (val) {
      this.isDimensionChange = false;
      this.isFirstLanding = false;
      // this.recalculateHeight();
      this.updateTotalBagVolumeWeight();
      this.isChangeWeight = false;
    }
  }

  changeWeight(val: any) {
    if (val) {
      this.isFirstLanding = false;
    }
  }

   async onUploadAdjustmentWeight(params: UploadMultiple) {
    if (!params.file) return;

    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const fileLink = await BookingController.uploadHydraFile(
        new UploadHydraFileRequest({
          attachFile: params.file,
          folderPath: "stt/"
        })
      );
      this.photoProof[params.index] = fileLink.data;
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, this.$t("bookingShipment.error.uploadPhoto"))
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onRemoveAdjustmentWeight(index: number) {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      const res = await BookingController.deleteHydraFile(
        new DeleteHydraFileRequest({
          attachFiles: [this.photoProof[index]]
        })
      );
      const statusDel = res.data[this.photoProof[index]];

      if (statusDel) {
        this.photoProof[index] = "";
      }
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal menghapus Foto ke storage!")
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
  
  mounted() {
    AccountController.checkAccountLocation();
    this.getDataDetail().then(() => {
      this.form.length = this.detailData.bagCustomLength,
      this.form.width = this.detailData.bagCustomWidth,
      this.form.height = this.detailData.bagCustomHeight,
      this.form.weight = this.formatWeightInput(this.detailData.totalBagGrossWeight);
    });
    this.refs = this.$refs;

    BaggingController.setScanFailedListKey("update-bagging-scan-failed");
  }

  unmounted() {
    this.setPartial(false);
    this.setFailed(false);
    this.setOpenSuccess(false);
  }

  onDeleteSttItem(item: SttNumberDetail) {
    this.hasClientId(this.whitelistFlags)
    this.sttNumberToDelete = item.sttNo;
    this.onDeleteSttNumber();
  }

  // fecth data for edit
  get id(): number {
    return Number(this.$route.params.id);
  }

  async getDataDetail() {
    return await BaggingController.getDetailBagging(this.id);
  }

  get detailData() {
    return BaggingController.baggingDetail;
  }

  get isLoading() {
    return BaggingController.isLoadingDetail;
  }
  get isError() {
    return BaggingController.isError;
  }
  get errorCause() {
    return BaggingController.errorCause;
  }

  closeModalErrorLoadBagging() {
    BaggingController.setError(false);
  }

  // get profile account
  get dataProfile(): AccountEntities {
    return AccountController.accountData;
  }

  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }

  // define bagging date
  get baggingDate() {
    return new Date(this.detailData.baggingDate);
  }

  // destination city
  fetchDestinationCity = debounce((search: string) => {
    LocationController.getCityList({
      search: search,
      status: "",
      page: 1,
      limit: 10
    });
  }, 250);

  get originCity() {
    const cityName = this.dataProfile.account_location.city_name;

    return `${this.dataProfile.account_location.city_code} - ${capitalize(
      cityName ? cityName.toLowerCase() : ""
    )}`;
  }

  get isInternal() {
    return this.dataProfile.account_type === "internal";
  }

  // add stt no
  isDuplicateScan = false;
  errorSttNumber: any = "";
  errorSttPieces = "";

  isScan = false;
  sttNumberListAdded: Array<any> = [];
  addScanSttNumber() {
    this.isScan = true;
    this.isFirstLanding = false;
    this.addSttToUpdate();
  }

  async addSttNumber() {
    this.hasClientId(this.whitelistFlags)
    this.isScan = false;
    this.addSttToUpdate();
  }

  onReset() {
    BaggingController.resetScanFailedList(new BaggingScanFailed({
      storageKey: "update-bagging-scan-failed"
    }));
  }

  get scanFailedList(): BaggingScanFailed[] {
    return BaggingController.scanFailedList;
  }
  addToScanFailedList(data: BaggingScanFailed) {
    BaggingController.addScanFailedList({
      ...data,
      storageKey: "update-bagging-scan-failed"
    });
  }

  async addSttToUpdate() {
    this.isFirstLanding = false;
    this.isErrorBagging = false;
    this.isAlertUnpaid = false;
    this.errorSttNumber = "";
    this.isDuplicateScan = false;
    let payload: any = {
      sttNumber: this.form.sttNumber,
      callback: this.addStt,
      storageKey: "update-bagging-scan-failed"
    };
    const isCheckTrackingSttFirst = this.checkSttorBagFormatNumber(
      this.form.sttNumber.trim()
    ); // this is for checking if it need to use tracking stt endpoint or not
    const isSttFromLilo = this.checkSttFromLilo(this.form.sttNumber.trim());

    payload = this.isInternal
      ? { ...payload, partnerId: this.detailData.partnerId }
      : payload;

    await this.checkTrackingSttFirst(
      isCheckTrackingSttFirst,
      payload,
      isSttFromLilo
    );
  }

  async checkTrackingSttFirst(
    isCheckTrackingSttFirst: any,
    payload: any,
    isSttFromLilo: any
  ) {
    if (!isCheckTrackingSttFirst) {
      const numberExceptSttorBag = this.form.sttNumber;
      await TrackingController.trackStt({
        sttNo: this.form.sttNumber.trim(),
        isGetSla: false,
        isSecondCall: false,
        cache: true
      }).then(async (isSuccess) => {
        if (isSuccess) {
          payload.sttNumber = this.sttDetail.sttNo;
        }
        await BaggingController.getDetailSttNumber(payload).then(() => {
          if (!isSttFromLilo && isSuccess) {
            this.detailData.sttResult.map((value) => {
              if (
                value.sttNo.toLowerCase() ==
                this.sttDetail.sttNo.toLocaleLowerCase()
              ) {
                value.sttNoRefExternal = numberExceptSttorBag; // this for put no refrence on table if scan except stt or bag
              }
              return value;
            });
          }
          return;
        });
      });
      return;
    }
    await BaggingController.getDetailSttNumber(payload);
  }

  checkSttorBagFormatNumber(value: string) {
    const sttPatern = /^\d{2}[a-z]{2}/; // check for stt number
    const bagPattern = /^[a-z]{3}-\d+$/; // check for bag number
    return (
      sttPatern.test(value.toLocaleLowerCase()) ||
      bagPattern.test(value.toLocaleLowerCase())
    );
  }

  checkSttFromLilo(value: string) {
    return isFormatLiloBag(value);
  }

  addStt(isGetSuccess: any) {
    if (isGetSuccess) {
      const checkErrorUpdate = isGetSuccess.find(
        (item: any) => item.isAllowUpdateStatus === false
      );
      const checkEligibleUpdate = isGetSuccess.map(
        (item: any) => item.isAllowUpdateStatus !== false
      );
      const checkErrorSttNeedAssessment = isGetSuccess.find(
        (item: any) =>
          item.stt.sttAssessmentStatus === "waiting" ||
          item.stt.sttAssessmentStatus === "rejected"
      );
      const isNotEligible = (val: any) => val === false;
      const detailSttBagging = BaggingController.detailSttno.data[0];
      if (checkErrorSttNeedAssessment) {
        this.isErrorBagging = true;
        playNotification("error");
        this.isAlertUnpaid = true;
        this.errorSttNumber =
          "Gagal scan karena adjustment STT belum disetujui tim Lion Parcel, tunggu dihubungi CS.";
        this.messageErrorNotification =
          "Silahkan menunggu CS follow up untuk konfirmasi adjust ulang STT. ";

        clearTimeout(this.notificationTimeout as NodeJS.Timeout);
        this.notificationTimeout = setTimeout(() => {
          this.notification = false;
        }, 15000);
        for (const detailSTT of isGetSuccess) {
          this.onFailedSttResults(detailSTT);
        }

        this.addToScanFailedList(new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          lastStatus: detailSttBagging.lastStatus,
          failureReason: this.errorSttNumber
        }))
      } else if (checkEligibleUpdate.every(isNotEligible)) {
        playNotification("error");
        this.isErrorTyping = true;
        this.errorSttNumber = checkErrorUpdate.errorMessage;
        this.addToScanFailedList(new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          lastStatus: detailSttBagging.lastStatus,
          failureReason: this.errorSttNumber
        }))
      } else {
        for (const detailSTT of isGetSuccess) {
          this.onValidateSttResults(detailSTT);
        }
      }
    }
  }

  onValidateSttResults(detailSTT: any) {
    this.isDuplicateScan = false;
    this.alertDangerousGoods = false;
    this.notification = false;
    const indexCurrentSttNumber = this.detailData.sttResult.findIndex(
      (data) => data.sttNo === detailSTT.stt.sttNo
    );
    if (indexCurrentSttNumber > -1) {
      this.isDuplicateScan = true;
      playNotification("duplicate");
      this.errorSttNumber = this.$t("STT Sudah Di Scan");
      this.isErrorTyping = true;

      this.addToScanFailedList(new BaggingScanFailed({
        sttNumber: this.form.sttNumber,
        lastStatus: detailSTT.lastStatus,
        failureReason: this.errorSttNumber,
        success: true
      }))
      return;
    } else if (!detailSTT.isPaid) {
      this.isUnpaid = true;
      this.isAlertUnpaid = true;
      playNotification("error");

      this.addToScanFailedList(new BaggingScanFailed({
        sttNumber: this.form.sttNumber,
        lastStatus: detailSTT.lastStatus,
        failureReason: this.errorSttNumber
      }))
    } else {
      const newSttNo = new SttResult({
        sttId: detailSTT.stt.sttId,
        sttNo: detailSTT.stt.sttNo,
        sttProductType: detailSTT.stt.sttProductType,
        sttTotalPiece: detailSTT.stt.sttTotalPiece,
        sttDestinationCityId: detailSTT.stt.sttDestinationCityId,
        sttOriginCityId: detailSTT.stt.sttOriginCityId || "",
        sttDestinationCityName: detailSTT.stt.sttDestinationCityName,
        sttWoodPacking: detailSTT.stt.sttWoodPacking,
        isWoodpacking: detailSTT.stt.isWoodpacking,
        sttCommodityCode: detailSTT.stt.sttCommodityCode,
        sttCommodityName: detailSTT.stt.sttCommodityName,
        sttGrossWeight: detailSTT.stt.sttGrossWeight,
        sttVolumeWeight: detailSTT.stt.sttVolumeWeight,
        sttChargeableWeight: detailSTT.stt.sttChargeableWeight,
        sttCodAmount: detailSTT.stt.sttCodAmount,
        sttLastStatusId: detailSTT.stt.sttLastStatusId,
        bookedAt: detailSTT.stt.bookedAt,
        sttPiece: detailSTT.stt.piece,
        sttNumberElexys: detailSTT.stt.sttNumberElexys,
        isDangerousGoods: detailSTT.stt.isDangerousGoods,
        sttClientId: detailSTT.stt.sttClientId
      });
      this.detailData.sttResult.push(newSttNo);
      this.sttNumberListAdded.push({
        // eslint-disable-next-line @typescript-eslint/camelcase
        stt_no: detailSTT.stt.sttNo,
        action: "add"
      });
      playNotification(getScanNotificationSound(detailSTT.stt), this.dataProfile.accountIsForeign);
      this.addToScanFailedList(
        new BaggingScanFailed({
          sttNumber: this.form.sttNumber,
          success: true
        })
      );
    }
    if (!detailSTT.isPaid || !detailSTT.isAllowUpdateStatus) return;
    const flags = getScanFlags(detailSTT.stt);
    this.detailSttNotification = {
      ...flags,
      sttNumber: detailSTT.stt.sttNo,
      destinationCity: detailSTT.stt.sttDestinationCityName,
      product: detailSTT.stt.sttProductType,
      woodpacking: detailSTT.stt.isWoodpacking,
      commodity: detailSTT.stt.sttCommodityName,
      totalPieces: detailSTT.stt.sttTotalPiece,
      codAmount: detailSTT.stt.sttCodAmount,
      sttNumberElexys: detailSTT.stt.sttNumberElexys,
      isDangerousGoods: detailSTT.stt.isDangerousGoods,
      cityId: detailSTT.stt.sttDestinationCityId,
      cityName: detailSTT.stt.sttDestinationCityName
    };
    this.form.sttNumber = "";
    this.form.cacheDestinationCity = this.form.destinationCity;
    this.fetchDestinationCity("");

    if (hasScanFlags(flags)) {
      this.notification = false;
      this.alertDangerousGoods = true;
    } else {
      this.alertDangerousGoods = false;
      this.notification = true;
    }

    // re focus
    const inputStt: any = this.$refs.inputStt;
    inputStt.focus();

    if (!this.isUnpaid) {
      clearTimeout(this.notificationTimeout as NodeJS.Timeout);
      this.notificationTimeout = setTimeout(() => {
        this.notification = false;
      }, 15000);
    }
  }

  onFailedSttResults(detailSTT: any) {
    this.detailSttNotification = {
      sttNumber: detailSTT.stt.sttNo,
      destinationCity: `${detailSTT.stt.sttDestinationCityId} - ${detailSTT.stt.sttDestinationCityName}`
    };

    this.notification = true;
  }

  onCloseNotification() {
    this.isUnpaid = false;
    this.isAlertUnpaid = false;
    this.errorSttNumber = "";
    this.isDuplicateScan = false;
  }

  get sttDetail() {
    return TrackingController.trackingSttData.sttDetail;
  }

  get isErrorAddSttNo() {
    return BaggingController.errorDetailSttNo;
  }

  get errorCauseAddSttNo() {
    return BaggingController.errorCauseDetailSttNo;
  }

  closModalErrorAddsttNo() {
    BaggingController.setErrorDetailSttNo(false);
  }

  // delete stt no
  showDeleteSttNumber = false;
  sttNumberToDelete = "";
  sttNumberSuccessDelete = "";
  errorSttNumberDelete = "";
  sttNumberListTrash: Array<any> = [];
  sttNumberDeletedPresent: Array<any> = [];
  onDeleteSttNumber() {
    this.sttNumberToDelete = this.sttNumberToDelete.split("#")[0];
    if (this.sttNumberToDelete) {
      this.isFirstLanding = false;
      this.errorSttNumberDelete = "";
      this.sttNumberSuccessDelete = "";
      this.sttNumberToDelete = this.sttNumberToDelete.toUpperCase();

      const indexSttNumber = this.detailData.sttResult.findIndex(
        (data: any) => {
          return (
            data.sttNo === this.sttNumberToDelete ||
            data.sttNumberElexys === this.sttNumberToDelete
          );
        }
      );

      if (indexSttNumber < 0) {
        this.errorSttNumberDelete = this.$t(
          "No. STT tidak ditemukan/sudah terhapus"
        );
      } else if (this.detailData.sttResult.length <= 1) {
        this.errorSttNumberDelete = this.$t(
          "No. STT tidak dapat dihapus. Minimal barang pengiriman bagging adalah 1 STT."
        );
        return;
      } else {
        const indexSttNumberAdded = this.sttNumberListAdded.findIndex(
          (item: any) => {
            return item.stt_no === this.sttNumberToDelete;
          }
        );
        if (indexSttNumberAdded >= 0) {
          this.sttNumberListAdded.splice(indexSttNumberAdded, 1);
        } else {
          this.sttNumberListTrash.push({
            // eslint-disable-next-line @typescript-eslint/camelcase
            stt_no: this.detailData.sttResult[indexSttNumber].sttNo,
            action: "remove"
          });
        }
        this.detailData.sttResult.splice(indexSttNumber, 1);
        this.sttNumberDeletedPresent.push(this.sttNumberToDelete);
        this.sttNumberSuccessDelete = this.sttNumberToDelete;
        this.sttNumberToDelete = "";
      }
    }
    this.isUnpaid = false;
    const deleteStt: any = this.$refs.deleteStt;
    deleteStt?.focus();
  }
  onShowDelete() {
    this.errorSttNumberDelete = "";
    this.showDeleteSttNumber = true;
    this.sttNumberToDelete = "";
    this.sttNumberSuccessDelete = "";
  }
  onCloseDelete() {
    this.showDeleteSttNumber = false;
    this.sttNumberDeletedPresent = [];
    this.isUnpaid = false;
  }

  autoCalculateBagGrossWeight() {
    this.totalBagGrossWeight = this.detailData.sttResult.reduce(
      (total, item: SttResult) => {
        return total + item.sttGrossWeight;
      },
      0
    );
    if (!this.isFirstLanding) {
      this.detailData.totalBagChargeableWeight = this.parseWeightInput(this.form.weight);
    }
  }

  numberOnly(value: any) {
    return this.formatWeightInput(value);
  }

  onBlurWeight(value: any) {
    this.form.length = 90,
    this.form.width = 60,
    this.isChangeWeight = true;
    this.isFirstLanding = false;
    let newValue = this.parseWeightInput(value).toFixed(2);
    const decimalDigit = Number(newValue.toString().split(".")[1]) * 10;
    if (decimalDigit < 100 && decimalDigit != 0) {
      // check if decimal need te round up, hint: value need to less than 0.10 ex: 0.09
      const roundUpValue = Math.round(Number(newValue)) + 0.1;
      newValue = roundUpValue.toFixed(2);
    }

    if (value === "0") {
      // no need to round up if value equal 0
      newValue = value;
    }
    if (!this.isFirstLanding) {
      this.form.height = Math.floor(
        (this.parseWeightInput(value) * this.dimensionDivider) / (Number(this.form.length) * Number(this.form.width))
      );
    }
    if (this.isChangeWeight) {
    this.form.weight = this.formatWeightInput(Number(newValue));
    }
  }

  get totalStt() {
    return this.detailData.sttResult.length;
  }
  get totalPieces() {
    return this.detailData.sttResult.reduce((a: any, b: any) => {
      return a + b.sttPiece.length;
    }, 0);
  }
  get totalGrossWeight() {
    return this.detailData.totalGrossWeight;
  }
  get totalVolumeWeight() {
    return this.detailData.totalVolumeWeight;
  }
  get totalBagGrossWeight() {
    return this.detailData.totalBagGrossWeight;
  }
  set totalBagGrossWeight(newValue) {
    this.detailData.totalBagGrossWeight = newValue;
  }

   get weightRoundUpCustom() {
    const weight = this.parseWeightInput(this.form.weight);

      let rounded;
      if (weight < 1) {
        rounded = 1; // anything below 1 becomes 1
      } else {
        rounded = Math.round(weight); // otherwise normal rounding
      }

      return rounded.toString().replace(".", ",");
   }

get totalBagChargeableWeight(): number {
  if (this.isFirstLanding) {
    return this.detailData.totalBagChargeableWeight;
  }

  const weight = this.parseWeightInput(this.form.weight);
  const volume = Number(this.weightVolumeBag);

  return weight > volume ? weight : volume;
}


  get compareChargeable() {
    const weight = this.parseWeightInput(this.form.weight);
    return weight > this.detailData.totalBagChargeableWeight
      ? this.isValueDecimal(weight)
      : this.isValueDecimal(+this.detailData.totalBagChargeableWeight);
  }

  get totalDangerousGoods() {
    return this.detailData.sttResult.filter((stt) => stt.isDangerousGoods)
      .length;
  }

  get isErrorGrossWeight() {
    return !this.parseWeightInput(this.form.weight) && !this.isFirstLanding;
  }
  get isErrorDimension() {
    return !this.form.width || !this.form.length || !this.form.height;
  }
  get isFormValid() {
    return (
      this.form.weight === "0" ||
      this.totalBagVolumeWeight === 0 ||
      this.form.width === 0 ||
      this.form.length === 0 ||
      this.form.height === 0 ||
      (this.bagWeightOverSttWeight && !this.isUploadPhotoAdjustWeightValid && this.isValidationPhotoProofHasPermission && !this.isFirstLanding) ||
      this.isMaxWeightDispute
    );
  }

   get isUploadPhotoAdjustWeightValid() {
    return  this.photoProof.filter((photo) => photo).length > 0
  }

   get isFirstLandingUploadPhotoAdjustWeightValid() {
    return  this.detailData.photoProof.filter((photo) => photo).length > 0
  }

  // gross volume weight


  // form model
  form = {
    destinationCity: "",
    cacheDestinationCity: "",
    sttNumber: "",
    length: this.detailData.bagCustomLength,
    width: this.detailData.bagCustomWidth,
    height: this.detailData.bagCustomHeight,
    weight: "0",
  };

   photoProof: string[] = [];

  isUnpaid = false;
  isAlertUnpaid = false;
  get isDisableAddSttPieces() {
    return !this.form.sttNumber;
  }

  // panel pickup
  togglePanel(event: any) {
    const refs: any = this.$refs;
    refs.op?.toggle(event);
  }

  // notification handler
  notification = false;
  detailSttNotification: any = null;

  // table
  get columns() {
    const column = [
      {
        name: "No.",
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail, index: number) => {
          return `<div class="text-black-lp-300">${index + 1}</div>`;
        }
      },
      {
        name: `No. STT`,
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div data-testid="bagging-scan-update-column-stt-cell" class="text-black-lp-300"><span data-testid="bagging-scan-list-row-stt-no-${item.sttNo}">${item.sttNo}</span>${item.isWoodpacking ? `<br/><span class="woodpacking-chips" data-testid="bagging-scan-list-row-woodpacking-chip-${item.sttNo}">KAYU</span>` : ""}</div>`;
        }
      },
      {
        name: this.$t("No. Referensi"),
        styleHead: "w-48 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 break-all">${item.sttNoRefExternal}</div>`;
        }
      },
      {
        name: this.$t("Chargeable weight"),
        styleHead: "w-56 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttChargeableWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("Berat Kotor"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttGrossWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.volumeWeight"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${formatByCountry(item.sttVolumeWeight, { type: "weight", suffix: " kg" })}</div>`;
        }
      },
      {
        name: this.$t("bagging.koli"),
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: SttResult) => {
          return `<div class="text-black-lp-300">${item.sttTotalPiece}</div>`;
        }
      },
      {
        name: this.$t("bagging.tableTitle.serviceType"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 flex">
                  <div class="rounded px-2 py-0 bg-gray-lp-400">
                    ${item.sttProductType}
                  </div>
                </div>`;
        }
      },
      {
        name: this.$t("Komoditas"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 break-all">${item.sttCommodityName}</div>`;
        }
      },
      {
        name: this.$t("bagging.tableTitle.destinationType"),
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300 flex">
                  <div class="rounded px-2 py-0 bg-gray-lp-400">
                      ${item.sttDestinationCityId}
                  </div>
                </div>`;
        }
      },
      {
        name: "Dangerous Goods",
        styleHead: "w-50 text-left whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class="text-black-lp-300">${item.isDangerousGoods ? 'Yes' : 'No'}</div>`;
        }
      },
      {
        name: this.$t("bagging.action"),
        key: "button_column",
        styleHead: "w-40 text-center",
        styleButton: (item: SttNumberDetail) => {
          return {
            outline: true,
            title: this.$t("bagging.hapus"),
            textColor: "red-lp-700",
            color: "red-lp-700",
            customClass: "text-center w-full font-semibold px-2.5 py-2",
            small: false,
            iconLeft: "trash-red",
            compact: true,
            clickFunction: () => {this.onDeleteSttItem(item)}
          };
        },
      }
    ];

    if (!this.detailData.isPaid) {
      column.push({
        name: this.$t("bagging.payment"),
        styleHead: "w-48 text-left text-black-lp-300 whitespace-no-wrap",
        render: (item: SttNumberDetail) => {
          return `<div class='text-left ${
            item?.paymentStatus === "unpaid"
              ? "bg-yellow-lp-500"
              : "bg-green-lp-700"
          } text-white font-medium font-montserrat rounded-md px-3 py-1 whitespace-no-wrap text-12px xxl:text-14px'>${
            item?.paymentStatus === "unpaid"
              ? this.$t("Kurang Bayar")
              : this.$t("Sudah Lunas")
          }</div>`;
        }
      });
    }
    return column;
  }

  // error handling
  isErrorTyping = false;
  isPartial = false;
  isFailed = false;

  setPartial(value: boolean) {
    this.isPartial = value;
  }

  setFailed(value: boolean) {
    this.isFailed = value;
  }

  setOpenSuccess(value: boolean) {
    this.openSuccess = value;
  }

  onClosePartial() {
    this.isPartial = false;
  }

  onResetIsAlreadyExist() {
    this.form.sttNumber = "";
    this.errorSttNumber = "";
    this.isDuplicateScan = false;
    this.isErrorTyping = false;
    // re focus
    const inputStt: any = this.$refs.inputStt;
    inputStt.focus();
  }

  get alertPopup() {
    const onDownload = () =>
      this.downloadCsvFailedStt({
        fileName: "bagging_update_stt_failed.csv",
        listStt: this.sttFailedList
      });
    // if success
    if (this.openSuccess) {
      return {
        onClick: () => this.onCloseSuccess(),
        title: this.$t("bagging.updateSuccessTitle"),
        message: this.$t("bagging.successEditBagTitle", {
          bagNo: this.detailData.bagVendorNo
            ? this.detailData.bagVendorNo
            : this.detailData.bagNumber
        }),
        image: "image-modal-success"
      };
    }

    // // if error typing not found
    if (this.isErrorTyping) {
      return {
        onClick: () => this.onResetIsAlreadyExist(),
        title: this.isDuplicateScan ? this.$t("STT Sudah Di Scan") : this.isScan
          ? this.$t("bagging.scanSttFailedTitle")
          : this.$t("bagging.addSttFailedTitle"),
        message: this.isDuplicateScan ? "" : this.$t(this.errorSttNumber),
        image: this.isDuplicateScan ? "image-modal-success" : "image-modal-failed"
      };
    }

    // if error typing not found
    if (this.isPartial) {
      return {
        onClick: () => this.onClosePartial(),
        onDownload: onDownload,
        title: this.$t("bagging.updatePartialTitle"),
        message: this.$t("bagging.updatePartialMessage"),
        image: "image-modal-warning"
      };
    }
    

    // default is failed
    return {
      onClick: () => this.setFailed(false),
      onDownload: onDownload,
      title: this.$t("bagging.updateFailedTitle"),
      message: this.$t("bagging.updateFailedMessage"),
      image: "image-modal-failed"
    };
  }

  withPrint = false;
  countSuccess = 0;
  countFailed = 0;
  sttFailedList: Array<string> = [];

  onDelaySave = debounce((id: number) => {
    this.onSave(id);
  }, 250);

  onShowLoadingSave() {
    // this.handleConfirmationSave(false);
    // MainAppController.showLoading();
    this.onSave(this.id);
  }

  async onSave(id: number) {
    const sttNos: Array<any> = this.sttNumberListAdded.concat( this.sttNumberListTrash);
    let payload: any = {
      bagId: id,
      customGrossWeight: this.parseWeightInput(this.form.weight),
      customLength: this.form.length,
      customWidth: this.form.width,
      customHeight: this.form.height,
      bagSttNo: sttNos,
      onRetry: this.onSave,
      totalBagChargeableWeight: this.totalBagChargeableWeight,
      totalSttDgCount: this.totalDangerousGoods,
      totalPieceSttDgCount: this.totalDangerousGoods,
      totalSttGrossWeight: this.grossWeight,
      totalSttVolumeWeight: this.volumeWeight,
      totalSttChargeableWeight: this.sttChargeableWeight,
      isUseNewCalculation: true,
      photoProof: this.photoProof,
      customVolumeWeight: this.weightVolumeBag
    };
    payload = this.isInternal
      ? { ...payload, partnerId: this.detailData.partnerId }
      : payload;
    const update: ResponseUpdate = await BaggingController.updateBagging(
      payload
    );
    if (update) {
      if (this.withPrint) {
        MainAppController.showLoading();
        const printLabel = await BaggingController.getDetailBagging(
          BaggingController.baggingId
        );
        if (printLabel) {
          const detailData = BaggingController.baggingDetail;
          const labelData = new BaggingData({
            bagId: BaggingController.baggingId,
            bagCode: detailData.bagNumber,
            bagPartnerId: 0,
            bagPartnerCode: "",
            bagPartnerName: detailData.partnerName,
            bagOriginCityCode: detailData.originCity.slice(0, 3),
            bagOriginCityName: detailData.originCity.substring(
              6,
              detailData.originCity.length
            ),
            bagOriginTransitCityCode: "",
            bagOriginTransitCityName: "",
            bagDestinationCityCode: detailData.destinationCity.slice(0, 3),
            bagDestinationCityName: detailData.destinationCity.substring(
              6,
              detailData.destinationCity.length
            ),
            bagTotalStt: this.totalStt,
            bagTotalGrossWeight: this.totalGrossWeight,
            bagTotalVolumeWeight: this.totalVolumeWeight,
            bagTotalChargeableWeight: this.detailData.totalBagChargeableWeight,
            bagTotalPiece: this.totalPieces,
            bagCreatedAt: new Date(detailData.baggingDate).toISOString(),
            bagCreatedBy: 0,
            bagCreatedName: "",
            bagCustomGrossWeight: this.totalBagGrossWeight,
            bagCustomVolumeWeight: this.detailData.totalBagChargeableWeight,
            userType: ""
          });
          this.refs.print.printLabel(labelData, detailData.bagVendorNo);
        }
        MainAppController.closeLoading();
      }

      if (update.totalSttSuccess > 0 && update.totalSttFailed > 0) {
        this.countFailed = update.totalSttSuccess;
        this.countSuccess = update.totalSttFailed;
        this.isPartial = true;
      } else if (update.totalSttFailed > 0) {
        this.sttFailedList = update.sttFailed;
        this.countFailed = update.totalSttFailed;
        this.isFailed = true;
      } else {
        this.onReset();
        this.openSuccess = true;
      }
    } else {
      this.closeModalErrorUpdate();
    }
  }

  closeModalErrorUpdate() {
    this.openConfirmationSave = false;
    BaggingController.setErrorUpdate(false);
    this.photoProof = [];
  }

  createAndPrint(withPrint: boolean) {
    const refs: any = this.$refs;
    refs.op?.hide();
    this.withPrint = withPrint;
    this.handleConfirmationSave(true);
  }

  // convert value decimal
  isValueDecimal(value: number): number | string {
    return convertDecimal(value);
  }

  // handle route leave and modal
  // navigation
  openSuccess = false;
  openConfirmationLeave = false;
  openConfirmationSave = false;
  answer = false;
  newPath = "";
  handleConfirmationLeave(value: boolean) {
    this.openConfirmationLeave = value;
  }
  handleConfirmationSave(value: boolean) {
    this.openConfirmationSave = value;
  }
  goBack() {
    this.$router.push(`${this.$route.matched[0].path}/${this.id}`);
  }
  onOpenClosePage(to: any) {
    this.handleConfirmationLeave(true);
    this.newPath = to.path;
  }
  handlerClose() {
    this.handleConfirmationLeave(false);
    this.answer = true;
    this.$router.push(this.newPath);
    this.onReset();
  }
  handlerCancelClose() {
    this.answer = false;
    this.handleConfirmationLeave(false);
  }
  onCloseSuccess() {
    this.goBack();
  }

  onConfirmDangerousGoods() {
    this.alertDangerousGoods = false;
    this.notification = true;

    // re focus
    const inputStt: any = this.refs.inputStt;
    inputStt.focus();
  }

  formatNoDecimal(value: string) {
    const valueNumberOnly = this.numberOnly(value);
    return formatInputNoDecimal(valueNumberOnly);
  }

  onBlurGrossWeight() {
    const convertWeight = this.parseWeightInput(this.form.weight);
    this.form.weight = this.formatWeightInput(
      convertWeight <= 0.09 ? 0.1 : convertWeight
    );
  }

  get dimensionDivider() {
    return FlagsPermissionBagging.config_dimension_divider.getValue();
  }
}
